/*
 * Slide-cart add-to-cart bridge + button spinner.
 *
 * 1) SPINNER: on click of any add-to-cart button (capture phase, so it fires no
 *    matter which script actually processes the add) we flag the button with
 *    `is-adding-to-cart` and keep it until the slide cart opens (the cart adds
 *    `slide-cart-open` to <body>) — with a safety timeout so it never sticks.
 *
 * 2) AJAX BRIDGE: for the standard product form we intercept the submit in the
 *    capture phase, AJAX-add, and fire `ajaxProduct:added` so the ported slide
 *    cart opens & refreshes (the old Preact SuperCart that used to do this is
 *    disabled).
 */
(function () {
  function setLoading(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-adding-to-cart', !!on);
    if (on) btn.setAttribute('aria-busy', 'true');
    else btn.removeAttribute('aria-busy');
  }

  // Resolve once the slide cart is open, or after a safety timeout.
  function whenCartOpens(cb) {
    if (document.body.classList.contains('slide-cart-open')) {
      // Cart already open — still show the spinner briefly so the click feels responsive.
      setTimeout(cb, 400);
      return;
    }
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      clearTimeout(timer);
      if (obs) obs.disconnect();
      cb();
    }
    var obs = new MutationObserver(function () {
      if (document.body.classList.contains('slide-cart-open')) finish();
    });
    obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    var timer = setTimeout(finish, 10000); // fallback so the button never stays stuck
  }

  // ---- 1) Spinner on click (mechanism-agnostic) ----
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.add-to-cart') : null;
      if (!btn) return;
      // Skip the dynamic "Buy It Now" button (it goes to checkout, not the drawer).
      if (btn.id === 'unify-support-buy-now') return;
      if (btn.getAttribute('aria-disabled') === 'true' || btn.disabled) return;

      setLoading(btn, true);
      whenCartOpens(function () { setLoading(btn, false); });
    },
    true // capture
  );

  // ---- 2) AJAX add for the standard product form ----
  function isProductForm(el) {
    return el && el.classList && el.classList.contains('product-single__form');
  }
  function getButton(form) {
    return form.querySelector('button[type="submit"], .add-to-cart:not(#unify-support-buy-now), [type="submit"]');
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!isProductForm(form)) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var btn = getButton(form);
      setLoading(btn, true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          return r.json().then(function (body) {
            return { ok: r.ok, body: body };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            setLoading(btn, false);
            console.error('[slide-cart] add to cart failed:', res.body);
            var msg = (res.body && (res.body.description || res.body.message)) || 'Sorry, this item could not be added to your cart.';
            window.alert(msg);
            return;
          }

          var item = res.body;
          try {
            if (window.fbq) {
              window.fbq('track', 'AddToCart', {
                content_name: item.title,
                content_ids: [item.variant_id],
                content_type: 'product',
                value: (item.final_line_price || item.line_price || 0) / 100,
                currency: 'USD'
              });
            }
          } catch (ex) {}

          // Open + refresh the slide cart.
          if (window.jQuery) {
            try { window.jQuery(document).trigger('ajaxProduct:added', item); } catch (ex) {}
          }
          try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: item })); } catch (ex) {}

          whenCartOpens(function () { setLoading(btn, false); });
        })
        .catch(function (err) {
          setLoading(btn, false);
          console.error('[slide-cart] add to cart error:', err);
        });
    },
    true // capture
  );
})();
